import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Grid, IconButton, Modal, Paper, Typography } from "@mui/material";
import React, { useState } from "react";
import { askForRescheduleApi } from "../../../API/schedule";
import theme from "../../../theme/theme";
import { toWallClockDate } from "../../../utils/formateDate";
import { errorResponseHandler, successResponseHandler } from "../../../utils/reposeAlert";
import MeetingDatePicker from "../../Meeting/MeetingDatePicker";
import SharedButton from "../../Shared/SharedButton";

const AskForRescheduleModal = ({ openResModal, closeResModalHandler, meetingId }) => {
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: "100%",
      md: "45rem",
    },
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 2,
    pt: 5,
  };
  // startTime/endTime = the local Date shown in the pickers.
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [disabledAddMeeting, setDisabledAddMeeting] = useState(false);

  const handleStartTimeChange = (date) => {
    setStartTime(date);
    // Default the end to one hour after the new start.
    const end = new Date(date);
    end.setHours(end.getHours() + 1);
    setEndTime(end);
  };

  const handleEndTimeChange = (date) => {
    setEndTime(date);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    askForResHandler();
  };

  const askForResHandler = async () => {
    if (!startTime || !endTime) return;
    setDisabledAddMeeting(true);
    // Send the picked wall-clock as UTC digits (matches backend/mobile).
    const startDate = toWallClockDate(startTime).toISOString();
    const endDate = toWallClockDate(endTime).toISOString();
    await askForRescheduleApi(meetingId, startDate, endDate)
      .then((response) => {
        if (response.status === 200) {
          successResponseHandler(`Sent`, response.data.message);
          closeResModalHandler();
        }
      })
      .catch((error) => {
        const msg = error.response?.data || error.message;
        errorResponseHandler(`Failed`, msg);
      })
      .finally(() => {
        setStartTime(null);
        setEndTime(null);
        setDisabledAddMeeting(false);
      });
  };

  return (
    <Modal
      open={openResModal}
      onClose={closeResModalHandler}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        zIndex: 10,
      }}
    >
      <Paper elevation={3} sx={modalStyle}>
        <Box style={{ position: "absolute", top: "0.5rem", left: "0.5rem" }}>
          <IconButton
            onClick={closeResModalHandler}
            sx={{
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography
          variant="h4"
          sx={{
            color: theme.palette.primary.main,
            fontWeight: "bold",
            marginBottom: "2rem",
          }}
        >
          Ask For Reschedule
        </Typography>
        <form onSubmit={submitHandler}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <MeetingDatePicker label="New Start Time" handleChange={handleStartTimeChange} value={startTime} />
            </Grid>
            <Grid item xs={12} md={6}>
              <MeetingDatePicker label="New End Time" handleChange={handleEndTimeChange} value={endTime} />
            </Grid>
            <Grid item xs={12}>
              <Box
                sx={{
                  borderTop: `1px solid ${theme.palette.primary.main}`,
                  paddingTop: "1rem",
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button variant="outlined" color="secondary" onClick={closeResModalHandler}>
                  Cancel
                </Button>
                <SharedButton
                  color="primary"
                  text="Send"
                  disabled={disabledAddMeeting || !startTime || !endTime}
                  type="submit"
                />
              </Box>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Modal>
  );
};

export default AskForRescheduleModal;
